import axios from "../../utils/axios";

export const getPost = async (id) => {
    const response = await axios.get(`/blogs/${id}`);

    return response.data;
};

export const updatePost = async (id, fieldName, value) => {
    const data = JSON.stringify({
        [fieldName]: value
    })
    const response = await axios.patch(`/blogs/${id}`, { [fieldName]:value });
    console.info(response);
    return response.data;
}
